



















































import { Vue, Component, Prop } from 'vue-property-decorator';

import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';

import { STATUS, STATUS_EXPLAINING } from '@/const/status';
import { IInventory } from '@/pages/campaign/adset/editingTypes';

@Component<AdsetTableOfStatus>({
    name: 'AdsetTableOfStatus',
})
export default class AdsetTableOfStatus extends Vue {
    @Prop({ type: Array, required: true }) private value!: IInventory[];
    get targets() { return this.value }
    set targets(v: IInventory[]) { this.$emit('input', v) }

    private compTerms = compTerms;
    
    private activeValue: STATUS = STATUS.ACTIVE;
    private inactiveValue: STATUS = STATUS.INACTIVE;

    private STATUS = STATUS;
    private STATUS_EXPLAINING = STATUS_EXPLAINING;

    private statusSelected: IInventory[] = [];

    private statusRowSelectedHandler(val: IInventory[]) {this.statusSelected = val}
    private setStatusToSelected(status: STATUS) {
        if (status === STATUS.ACTIVE) {
            this.statusSelected.forEach((item: IInventory) => {item.status |= STATUS.ACTIVE});
        } else if ( status === STATUS.INACTIVE) {
            this.statusSelected.forEach((item: IInventory) => {item.status &= ~STATUS.ACTIVE});
        }
    }
}
